export class Log {
  tenant: string;
  creationUser: string;
  location: string;
  logMessage: string;
}
